var _style, _circle, _path, _g, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFDA44;}\n\t.st1{fill:#A2001D;}\n\t.st2{fill:#6DA544;}\n\t.st3{fill:#0052B4;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512,256c0-87.9-44.3-165.4-111.7-211.5H111.7C44.3,90.6,0,168.1,0,256c0,87.9,44.3,165.4,111.7,211.5h288.6 C467.7,421.4,512,343.9,512,256z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.3,189.2h111.3v-44.5l-22.3,11.1L256,122.4l-33.4,33.4l-22.3-11.1L200.3,189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.2,256h-55.6c2.2-3.8,3.5-8.1,3.5-12.8c0-14.2-11.5-25.7-25.7-25.7c-9.8,0-18.3,5.5-22.6,13.6 c-4.3-8.1-12.8-13.6-22.6-13.6c-14.2,0-25.7,11.5-25.7,25.7c0,4.7,1.3,9,3.4,12.8h-55c0,17,14.8,30.8,31.8,30.8h-1 c0,14,9.3,25.8,22,29.5l-25,25l23.6,23.6l33.5-33.5c1.3,0.5,2.7,0.9,4.1,1.1l-20.2,45.7c9.7,3.9,20.3,6.1,31.4,6.1 c11.1,0,21.7-2.2,31.4-6.1l-20.2-45.7c1.4-0.3,2.8-0.6,4.1-1.1l33.5,33.5l23.6-23.6l-25-25c12.7-3.8,22-15.6,22-29.5h-1 C341.3,286.8,356.2,273,356.2,256L356.2,256z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,272.7l-36.2,16.7v33.4L256,345l36.2-22.3v-33.4L256,272.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M219.8,256h72.3v44.5h-72.3L219.8,256z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMe);
export default __webpack_public_path__ + "static/media/me.5371c39fcfa75f27bd1989481e761c37.svg";
export { ForwardRef as ReactComponent };